import { useSelector } from "react-redux"
import { DataGrid } from "../../components"
import { getLocalized } from "../../redux/localization"
import { adminEmailTemplatesUrl } from "../../services/urls"
import createEmailTemplateForm from "./create"
import EmailTemplateDetail from "./detail"

const EmailTemplatePage = () => {

    const localize = useSelector(getLocalized)
    const columns = [
        {
            dataField: "Name",
            caption: localize.getString("name")
        },
        {
            dataField: "EmailTemplateType",
            caption: localize.getString("emailTemplateType")
        },
        {
            dataField: "Active",
            caption: localize.getString("isActive")
        }
    ]

    return <DataGrid
        url={adminEmailTemplatesUrl}
        getByIdUrl={adminEmailTemplatesUrl}
        columns={columns}
        refObject={{}}
        title="E Posta Şablonları"
        details={{
            width: "40%",
            height: "80%",
            getByIdUrl: adminEmailTemplatesUrl,
            title: localize.getString("emailTempleteDetail"),
            component: EmailTemplateDetail,
        }}
        create={{
            createUrl: adminEmailTemplatesUrl,
            component: createEmailTemplateForm,
            width: "60%",
            height: "85%",
            title: localize.getString("createEmailTemplate"),
           
        }}
        edit={{
            editUrl: adminEmailTemplatesUrl,
            component: createEmailTemplateForm,
            width: "60%",
            height: "85%",
            title: localize.getString("editEmailTemplate")
        }}
        remove={{
            url: adminEmailTemplatesUrl
        }}
    />
}

export default EmailTemplatePage;